module.exports = __webpack_public_path__ + "img/new_index_customers9.bfee08e1.png";